import "./ClassicPage.css";

export default function ClassicPage() {
  return (
    <main className="classic-page">
      <iframe
        className="classic-page__frame"
        src="/classic/index.html"
        title="Previous animated portfolio"
      />
      <a className="classic-page__back" href="/">
        ← Current design
      </a>
    </main>
  );
}
